import { Input } from "@/components/atoms/input";

interface ProfileFormProps {
  userData: any;
  isEditMode: boolean;
  editedName: string;
  nameError: string;
  onNameChange: (value: string) => void;
  onNameBlur: () => void;
}

export default function ProfileForm({
  userData,
  isEditMode,
  editedName,
  nameError,
  onNameChange,
  onNameBlur,
}: ProfileFormProps) {
  // Helper function to get user brands
  const getUserBrands = () => {
    if (
      userData?.roleSpecificData?.brands &&
      Array.isArray(userData.roleSpecificData.brands)
    ) {
      return userData.roleSpecificData.brands.map(
        (brand: { id: number; name: string }) => brand.name,
      );
    }
    return [];
  };

  // Helper function to render brand tags responsively
  const renderBrandTags = () => {
    const brands = getUserBrands();
    if (brands.length === 0) {
      return (
        <span className="text-gray-500 text-xs sm:text-sm">
          Sin marca asignada
        </span>
      );
    }

    return brands.map((brandName: string, index: number) => (
      <span
        key={`${brandName}-${index}`}
        className="bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 sm:px-2.5 sm:py-0.5 rounded-full break-all"
      >
        {brandName}
      </span>
    ));
  };

  return (
    <div className="flex-1 grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4 w-full">
      <div className="col-span-1">
        <label
          htmlFor="name"
          className="block text-xs sm:text-sm font-medium text-gray-700 mb-1"
        >
          Nombre completo
        </label>
        {isEditMode ? (
          <div>
            <Input
              id="name"
              value={editedName}
              onChange={(e) => onNameChange(e.target.value)}
              onBlur={onNameBlur}
              className={`bg-white text-xs sm:text-sm ${nameError ? "border-red-300 focus:border-red-300 focus:ring-red-200" : "border-gray-300"}`}
              placeholder="Nombre Apellido"
            />
            {nameError && (
              <p className="text-xs text-red-600 mt-1">{nameError}</p>
            )}
          </div>
        ) : (
          <div className="min-h-[36px] sm:min-h-[40px] bg-gray-50 border border-gray-200 rounded-md px-2 sm:px-3 py-2 flex items-center">
            <span className="text-gray-500 text-xs sm:text-sm break-all">
              {userData.auth0Profile?.name ||
                userData.auth0Profile?.nickname ||
                ""}
            </span>
          </div>
        )}
      </div>
      <div className="col-span-1">
        <label
          htmlFor="email"
          className="block text-xs sm:text-sm font-medium text-gray-700 mb-1"
        >
          Email
        </label>
        <div className="min-h-[36px] sm:min-h-[40px] bg-gray-50 border border-gray-200 rounded-md px-2 sm:px-3 py-2 flex items-center">
          <span className="text-gray-500 text-xs sm:text-sm break-all">
            {userData.auth0Profile?.email || ""}
          </span>
        </div>
      </div>

      <div className="col-span-1">
        <label
          htmlFor="role"
          className="block text-xs sm:text-sm font-medium text-gray-700 mb-1"
        >
          Rol
        </label>
        <div className="min-h-[36px] sm:min-h-[40px] bg-gray-50 border border-gray-200 rounded-md px-2 sm:px-3 py-2 flex items-center">
          <span className="text-gray-500 text-xs sm:text-sm">
            {userData.roles?.length > 0 ? userData.roles[0] : "Sin rol"}
          </span>
        </div>
      </div>
      <div className="col-span-1">
        <label
          htmlFor="brands"
          className="block text-xs sm:text-sm font-medium text-gray-700 mb-1"
        >
          Marca(s)
        </label>
        <div className="min-h-[36px] sm:min-h-[40px] bg-gray-50 border border-gray-200 rounded-md px-2 sm:px-3 py-2 flex flex-wrap gap-1 sm:gap-2 items-center">
          {renderBrandTags()}
        </div>
      </div>
    </div>
  );
}
